import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "rs-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrl: "./page-not-found.component.scss",
  standalone: false
})
export class PageNotFoundComponent {
  constructor(private router: Router) {}

  homeOnClick() {
    this.router.navigate(["/"]);
  }
}
